import { x } from '@xstyled/styled-components';
import React from 'react';
import {
  Item,
  ItemDefinition,
  ItemValidationError,
  registry,
  RenderProps
} from '../Item';
import { FLIP_CARD, FLIP_FRONT } from '../itemIds';

export type FlipFrontDefinition = ItemDefinition<typeof FLIP_FRONT, void>;

export class FlipFront extends Item<typeof FLIP_FRONT, void> {
  protected validate() {
    if (this.parent?.type !== FLIP_CARD) {
      throw new ItemValidationError(
        `An item of type [${FLIP_FRONT}] must be the child of an item of type [${FLIP_CARD}]`
      );
    }
  }

  protected render({ children }: RenderProps<void>) {
    return (
      <x.div overflow="auto" h="100%">
        {children}
      </x.div>
    );
  }
}

registry[FLIP_FRONT] = FlipFront;
